var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "filter-bar" },
    [
      _vm.filters.length
        ? _vm._l(_vm.filters, function(nav, index) {
            return _c(
              "div",
              { staticClass: "filter-bar__item" },
              [
                _vm._v("\n\t\t\t" + _vm._s(nav.title) + ":\n\t\t\t\n\t\t\t"),
                _c("filter-nav", {
                  attrs: { items: nav.tags, show: index === _vm.openNavIndex },
                  on: {
                    toggle: function($event) {
                      return _vm.toggleNav(index)
                    },
                    close: _vm.closeNav
                  }
                })
              ],
              1
            )
          })
        : _vm._e(),
      _c("div", { staticClass: "filter-bar__item filter-bar__count" }, [
        _vm._v("\n\t\t" + _vm._s(_vm.count) + "\n\t")
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-561d8530", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-561d8530","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/FilterBar.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-561d8530","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/FilterBar.vue
// module chunks = 0